/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventpreview1Inputs */

const en_eventpreview1 = /** @type {(inputs: Eventpreview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Preview`)
};

const de_eventpreview1 = /** @type {(inputs: Eventpreview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventvorschau`)
};

/**
* | output |
* | --- |
* | "Event Preview" |
*
* @param {Eventpreview1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventpreview1 = /** @type {((inputs?: Eventpreview1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventpreview1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventpreview1(inputs)
	return de_eventpreview1(inputs)
});
export { eventpreview1 as "eventPreview" }